// extracted by mini-css-extract-plugin
export default {"truncated":"TruncatedText_truncated__-m9ks","tooltipBubble":"TruncatedText_tooltipBubble__TS+rg","tooltipFadeIn":"TruncatedText_tooltipFadeIn__4jNLT"};